import { useState, useEffect } from "react";
import SettingsCommonLayout from "./SettingsCommonLayout";
import Loader from "@/shared/components/ui/Loaders/Loader";
import {
  useOpenAIKey,
  useSetOpenAIKey,
  // useDeleteOpenAIKey,
} from "@/hooks/useOpenAIKey";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import CommonInput from "@/shared/components/ui/Input/CommonInput";
import CommonSelect from "@/shared/components/ui/Select/CommonSelect";
import { LLM_PROVIDERS } from "@/shared/utils/onboardingConfig";

export default function OpenAIKeySettings({ tab }) {
  const { data, isLoading } = useOpenAIKey();
  const { mutate: saveKey, isPending: isSaving } = useSetOpenAIKey();
  // const { mutate: removeKey, isPending: isDeleting } = useDeleteOpenAIKey();

  const [inputValue, setInputValue] = useState("");
  const [showInput, setShowInput] = useState(false);
  // const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [provider, setProvider] = useState("openai");

  useEffect(() => {
    if (data?.provider) setProvider(data.provider);
  }, [data?.provider]);
  const handleSave = () => {
    if (!inputValue.startsWith("sk-") || inputValue.length < 20) return;
    saveKey(inputValue, {
      onSuccess: () => {
        setInputValue("");
        setShowInput(false);
      },
    });
  };

  // const handleDelete = () => {
  //   removeKey(undefined, { onSuccess: () => setShowConfirmDelete(false) });
  // };

  return (
    <SettingsCommonLayout
      title="Api Key"
      description="Connect your own API account. Usage and billing will be attributed to your key."
      tab={tab}
    >
      {isLoading ? (
        <Loader text="Loading..." />
      ) : (
        <div className="mt-6 max-w-lg flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-gray-800">
              Provider
            </label>
            <CommonSelect
              options={LLM_PROVIDERS.map((p) => ({
                label: p.name,
                value: p.id,
                disabled: p.disabled,
              }))}
              placeholder="Select Provider"
              value={provider}
              onChange={(value) => setProvider(value)}
              classNames={{
                base: "bg-white w-[142px]",
                mainWrapper: "w-[142px]",
                trigger: "bg-white border border-gray-300 shadow-none",
                popoverContent: "!min-w-[142px]",
              }}
            />
          </div>
          {data?.exists && !showInput ? (
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-sm font-semibold text-gray-800">
                  API Key
                </label>
                <div className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-gray-50">
                  <span className="font-mono text-sm text-gray-700">
                    sk-•••••••••••••••••••{data.last_4}
                  </span>
                  {data.last_rotated_at && (
                    <span className="text-xs text-gray-400 ml-auto">
                      Updated at{" "}
                      {new Date(data.last_rotated_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-2 self-end">
                <PrimaryButton
                  onClick={() => setShowInput(true)}
                  className="px-4 !py-4 text-white"
                  startContent={false}
                  size="md"
                >
                  Replace
                </PrimaryButton>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-2">
                <label className="text-sm font-semibold text-gray-800">
                  API Key
                </label>
                <CommonInput
                  type="password"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck={false}
                  data-1p-ignore
                  data-lpignore="true"
                  placeholder="sk-..."
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  className="p-4"
                />
              </div>
              <div className="flex gap-2 items-start justify-end">
                <PrimaryButton
                  disabled={
                    isSaving ||
                    !inputValue.startsWith("sk-") ||
                    inputValue.length < 20
                  }
                  onClick={handleSave}
                  size="md"
                  startContent={false}
                  isLoading={isSaving}
                >
                  {isSaving ? "Validating…" : "Save"}
                </PrimaryButton>
                {data?.exists && (
                  <SecondaryButton
                    title="Cancel"
                    onClick={() => {
                      setShowInput(false);
                      setInputValue("");
                      if (data?.provider) setProvider(data.provider);
                    }}
                    className="px-4 !py-3 border border-gray-300 text-gray-600 hover:bg-gray-50"
                  />
                )}
              </div>
            </div>
          )}

          {/* {showConfirmDelete && (
            <DeleteConfirmationModal
              icon={
                <Siren
                  size={56}
                  className="text-error-500 animate-pulse duration-300 ease-in-out"
                />
              }
              title="Remove your API key?"
              description="AI features will stop working until a new key is added."
              showConfirmDelete={showConfirmDelete}
              onClose={() => setShowConfirmDelete(false)}
              onDelete={handleDelete}
              deleteButtonText="Yes, remove"
              cancelButtonText="Cancel"
            />
          )} */}
        </div>
      )}
    </SettingsCommonLayout>
  );
}
